import { defineMessages } from 'react-intl';

export default defineMessages({
  modalTitle: {
    id: 'AddVismaSignModal.modalTitle',
    defaultMessage: 'Add Visma digital signature',
  },
  signerEmail: {
    id: 'AddVismaSignModal.signerEmail',
    defaultMessage: 'Signatory email',
  },
  addVismaSign: {
    id: 'AddVismaSignModal.addVismaSign',
    defaultMessage: 'Send invitation to sign the certificate',
  },
  confirmTitle: {
    id: 'AddVismaSignModal.confirmTitle',
    defaultMessage:
      'This action is irreversible, please confirm that the signatory email is correct',
  },
  invitatationToSignWillBeSentTo: {
    id: 'AddVismaSignModal.invitatationToSignWillBeSentTo',
    defaultMessage:
      'Invitation to sign certificate will be sent to <b>{signerEmail}</b><br/>Signatory will be able to use it during 90 days, if invitation have not been fulfilled, the process is cancelled',
  },
  saveLabel: {
    id: 'General.saveLabel',
    defaultMessage: 'Save',
  },
});
